import React from 'react'
import AboutUs from '../AboutUs/AboutUs'
import Team from '../Team/Team'
// import { NavLink, Outlet } from 'react-router-dom'


export default function AboutLayout() {
  return (
    <>
    <AboutUs/>
    <Team/>
    </> 
  )
}
